import { initialState } from './ai-session-context-plugin';
import type { SessionContextAction, SessionContextPluginState } from './types';

/**
 * Reduces AI experience context actions to update the plugin state.
 * Handles actions for resetting, prompt submission, streaming, completion, and errors.
 *
 * @param state - The current AI experience context plugin state
 * @param action - The action to process
 * @returns The updated AI experience context plugin state
 */
export function reducer({
	state,
	action,
}: {
	action: SessionContextAction;
	state: SessionContextPluginState;
}): SessionContextPluginState {
	switch (action.type) {
		case 'RESET':
			return initialState;
		case 'START_SESSION':
			return {
				...state,
				sessionId: action.sessionId,
				status: 'streaming',
			};
		case 'PROMPT':
			return {
				...state,
				status: 'prompt',
			};
		case 'STREAM':
			// Prevent streaming if the session is in an error state
			if (state.status === 'error') {
				return {
					...state,
				};
			}
			// if the previous state was complete it means we are starting a new stream
			const responseVersion = state.status === 'complete' ? 0 : state.responseVersion + 1;
			return {
				...state,
				adfResponse: action.adfResponse,
				status: 'streaming',
				responseVersion,
			};
		case 'COMPLETE':
			// Prevent completing the session if it is in an error state
			if (state.status === 'error') {
				return {
					...state,
				};
			}
			return {
				...state,
				adfResponse: action.adfResponse,
				status: 'complete',
			};
		case 'ERROR':
			return {
				...state,
				errorInfo: action.errorInfo,
				status: 'error',
			};
		default:
			return state;
	}
}
